import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface CreateRunFlowTaskParams {
  readonly scheduleId: string;
  readonly flowId: string;
  readonly runAllOutputs: boolean;
  readonly flowOutputStepIds: string[];
}

export class CreateRunFlowTaskRequest extends Request<CreateRunFlowTaskParams, IResult> {
  constructor(params: CreateRunFlowTaskParams) {
    super('createRunFlowTask', params);
  }
}
